/**
 * Convert image file to base64 string
 * @param {File} file - Image file to convert
 * @returns {Promise<string>} Base64 encoded string (without data URI prefix)
 */
export const convertImageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      // Remove data:image/...;base64, prefix
      // Backend will add it back if needed
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };

    reader.onerror = (error) => {
      reject(new Error('Failed to read image file'));
    };

    reader.readAsDataURL(file);
  });
};

/**
 * Validate image file type and size
 * @param {File} file - Image file to validate
 * @throws {Error} If validation fails
 * @returns {boolean} True if valid
 */
export const validateImageFile = (file) => {
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  const maxSize = 10 * 1024 * 1024; // 10MB in bytes

  // Check file type
  if (!validTypes.includes(file.type)) {
    throw new Error('Invalid file type. Please upload JPG, PNG, or WebP image.');
  }

  // Check file size
  if (file.size > maxSize) {
    throw new Error('File too large. Maximum size is 10MB.');
  }

  return true;
};
